import { Spin } from "antd";

interface Props {
  cy?: string;
}

// cy can be used to locate the element for cypress tests
// eslint-disable-next-line
export const Loader = ({ cy }: Props) => <Spin />;
